import { parseUserAgent } from 'react-device-detect';
import { BUILD } from '../../../utils/config';
export const HELP_CENTER_LABEL = {
  no: 'No',
  all: 'All',
  yes: 'Yes',
  open: 'Open',
  seeAll: 'See all',
  ticket: 'Ticket',
  resolved: 'Resolved',
  iNeedHelp: 'I need help',
  activeChat: 'Active chat',
  allTickets: 'All tickets',
  chatWithUs: 'Chat with us',
  helpCenter: 'Help center',
  openTickets: 'Open tickets',
  browseTopics: 'Browse topics',
  noTicketsYet: 'No tickets yet',
  raiseATicket: 'Raise a ticket',
  raiseEnquire: 'Raise an enquiry',
  wasItHelpful: 'Was it helpful?',
  reminderPopup: {
    heading: 'We’re working on it',
    viewTicket: 'View ticket',
    description:
      'Looks like you’ve already submitted an enquiry regarding this issue. Please continue using the ticket you’ve raised.',
    subDescription: 'If you need help with something else, please submit a new enquiry.'
  },
  stillNeedHelp: 'Still need help?',
  thankFeedback: 'Thank you for your feedback!',
  browseManually: 'browse the list manually',
  helpCenterHome: 'Help center home',
  tagNotSelected: 'tags are not empty.',
  cantFindInMatch:
    ' Can’t find a match for your search. Please try refining your search terms, or ',
  searchForATopic: 'Search for a topic',
  selectTheOption: 'Select the option that best suits your enquiry',
  cantFindInSearch:
    'Can’t find a match for your search. Please try refining your search terms, or browse the list manually',
  enquiryRelatesTo: 'Raise a query related to:',
  timeLineModalData: {
    paidTitle: 'Your transaction {transactionNumber}\nis successful. ',
    otherStatusDesc: 'Your funds should reach us by',
    otherStatusNote: 'Your transfer is moving as expected and you can track it anytime.',
    paidDescription: `We’ve transferred {grossSourceAmount} {sourceCurrency} 
      to your recipient. We suggest that you contact them to ensure they’ve received it.`,
    otherStatusDesc1: 'Should be paid out by',
    secondaryBtnText: 'New enquiry',
    trackYourTransfer: 'Track your transfer',
    otherStatusHeading: 'Your transaction {transactionNumber} is on track',
    viewTransferDetails: 'View transaction details',
    otherStatusNoteBankRefund:
      'Your transfer is moving as expected and your payment should reach your recipient soon.'
  },
  chatHistoryHeading: 'Chat history with Instarem',
  peopleFoundHelpful: '{COUNT} people find it helpful',
  amazeDisclaimerText:
    'Note, Instarem will never ask for your card or CVV number.\nNever disclose these details to anyone.',
  noTicketDescriptions: 'All your tickets will be shown here',
  searchTagPlaceHolder: 'Search for a topic',
  amazeTicketDisclaimer:
    'Note, Instarem will never ask for your card or CVV number.\nNever disclose these details to anyone.',
  enquiryFormSubHeading: 'Please provide the following details',
  negativeThankFeedback: 'Thank you for your feedback. We’ll make it better.',
  troubleLoginFormSubHeading: 'Please provide the following details',
  helpCenterHeaderDescriptions: 'How can we help you today?',
  ticketCreationSuccessMessage: `Thank you for writing to us.\nWe have received your request and your 
    ticket number is #{{{TICKET_NO}}} .\nWe will respond to your query shortly.\n Regards,\nTeam Instarem`,
  searchEmptyResultDescription1:
    'Can’t find a match for your search. Please try refining your search terms, or',
  searchEmptyResultDescription2: 'browse the list manually',
  transaction: 'Transaction',
  issueDescription: 'Issue description',
  textAreaPlaceholder: 'Type here',
  textInputPlaceholder: 'Type here',
  attachmentHeading: 'Attachment (if any)',
  textAreaLabel: 'Issue Description',
  textInputLabel: 'Select Txn No'
};

export const SEARCH_DEBOUNCE_TIME = 200;
export const RAISE_ENQUIRY_FORM = 'raiseEnquiryForm';

export const TICKET_PROPERTIES = {
  status: {
    open: 'open',
    closed: 'closed',
    resolved: 'resolved'
  },
  channel: {
    nativeMessaging: 'native_messaging',
    api: 'api',
    mobile: 'mobile_sdk'
  },
  rating: {
    good: 'good',
    bad: 'bad'
  }
};
export const TRANSACTION_HISTORY = 'TRANSACTION_HISTORY';
export const TRANSACTION_REQUIRED_FORM_FIELD = 'Text input';

export const FIELD_TYPES = {
  TEXT_INPUT: 'Text input',
  TEXT_AREA: 'Text area',
  ATTACHMENTS: 'Attachments',
  DROPDOWN: 'Dropdown list'
};
export const STATUS = {
  OPEN: 'OPEN'
};

/* eslint-disable no-unused-vars */
export enum AllowedCustomerSupportChannel {
  Ticket = 'Ticket',
  Chat = 'Chat'
}

export const AUTHORTYPE = {
  USER: 'USER',
  AGENT: 'AGENT'
};

export const ZENDESK_TICKET_CREATION_FIELD = {
  issueDescription: 'Issue description',
  dropdownKey: 'Selected dropdown item'
};

const {
  browser: { name: browserName, version: browserVersion },
  device: { model: deviceModel },
  os: { name: osName, version: osVersion }
} = parseUserAgent(window.navigator.userAgent);

enum METADATA_FIELDS_DEVELOPMENT {
  deviceOS = '24725072325531',
  deviceModel = '24725195468827',
  browserName = '24725117962907',
  deviceType = '21230818773275',
  levelOneSubject = '21230814830491',
  remittanceTags = '23999141178907',
  countryCode = '21230525983131',
  uniqueUserId = '21230506599835',
  chatSubject = '25053121479707',
  transactionNumber = '21228612994715'
}
enum METADATA_FIELDS_PROD {
  deviceOS = '24950398443803',
  deviceModel = '24950409265051',
  browserName = '24950635720219',
  deviceType = '24949702234651',
  levelOneSubject = '24949608725531',
  remittanceTags = '23999141178907',
  countryCode = '24951849070235',
  uniqueUserId = '24949505982619',
  chatSubject = '25054249627035',
  transactionNumber = '19050669663259'
}
export const METADATA_FIELDS =
  BUILD === 'prod' ? METADATA_FIELDS_PROD : METADATA_FIELDS_DEVELOPMENT;

// device m,eta data fields that will be passed when user initiates a new chat
/**
 * @param id -> id of the field to be initialised.
 * I will be generated by zendesk. It can be found under "fields" section oon zendesk admin portal
 * @param value -> value of the field
 *
 * we need to pass name of the OS, version of the OS, device model, OS brand, browser name, and browserVersion
 */
export const DEVICE_METADATA_FIELDS = [
  {
    id: METADATA_FIELDS.deviceOS,
    value: `${osName || ''} ${osVersion || ''}`
  },
  {
    id: METADATA_FIELDS.deviceModel,
    value: deviceModel || ''
  },
  {
    id: METADATA_FIELDS.browserName,
    value: `${browserName || ''} ${browserVersion || ''}`
  },

  {
    id: METADATA_FIELDS.deviceType,
    value: window.innerWidth <= 480 ? 'mobile_web' : 'web'
  }
];

export const AMAZE = 'amaze';

export const CUSTOM_INFORMATION_MESSAGE = {
  delayMessage: `Your request may take a few seconds. Please refresh the page or check back later.`,
  activeChat: `There is an active chat ongoing. To raise a new issue, consider raising a ticket.`
};
